import _ from 'lodash';

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';

export const getGhostComponentType = (
  editorAPI: EditorAPI,
  ghostRef: CompRef,
): string => {
  let ghostsMap =
    // @ts-expect-error
    editorAPI.dsRead.components.refComponents.getGhostRefComponents(
      getGhostDirectParent(ghostRef),
    );

  if (!_.has(ghostsMap, ghostRef.id)) {
    ghostsMap =
      // @ts-expect-error
      editorAPI.dsRead.components.refComponents.getGhostRefComponents(
        getGhostTopParent(ghostRef),
      );
  }

  if (!ghostsMap || !_.has(ghostsMap, ghostRef.id)) {
    return;
  }

  return ghostsMap[ghostRef.id]?.componentType;
};

export const isGhostComponent = (editorAPI: EditorAPI, ghostRef: CompRef) => {
  return getGhostComponentType(editorAPI, ghostRef) !== undefined;
};

const getGhostDirectParent = (ghostRef: CompRef) =>
  Object.assign({}, ghostRef, {
    id: ghostRef.id.substring(0, ghostRef.id.lastIndexOf('_r_')),
  });

const getGhostTopParent = (ghostRef: CompRef) =>
  Object.assign({}, ghostRef, { id: ghostRef.id.split('_r_')[0] });
